// Content Management Enums
export enum ContentVersionStatusEnum {
  "Draft" = 1,
  "Published" = 2,
  "Archived" = 3,
}

export enum ContentManagementTypeEnum {
  "Terms_Conditions" = 1,
  "Privacy_Policy" = 2,
  "Professional_Terms" = 3,
  "Emergency_Services" = 4,
  "Customer_Information" = 5,
  "Professional_Information" = 6,
  "Contact_Information" = 7,
}

export enum ContentReviewCycleEnum {
  "30Days" = 1,
  "60Days" = 2,
  "90Days" = 3,
}

// Content Management Interfaces
export interface ContentManagementVersion {
  id: string;
  name: string;
  status: {
    id: ContentVersionStatusEnum;
  };
  user: {
    id: string;
  };
  lastModified: string;
  effectiveDate: string;
  publishDate: string;
}

export interface ContentManagement {
  id: string;
  version: {
    id: string;
  };
  type: {
    id: ContentManagementTypeEnum;
  };
  reviewCycle: {
    id: ContentReviewCycleEnum;
  };
  autoSave: number;
  settingLanguage: {
    id: string;
  };
  isText: boolean;
  contentDescription: string;
  contentTitle: string;
}

export interface ContentManagementTranslation {
  id: string;
  content: string;
  title: string;
  language: {
    id: string;
  };
  contentManagementType: {
    id: string;
  };
}

// Extended interfaces for UI usage
export interface ContentManagementWithVersion extends ContentManagement {
  versionDetails?: ContentManagementVersion;
  translations?: ContentManagementTranslation[];
}

export interface ContentManagementVersionWithContent extends ContentManagementVersion {
  contentManagement?: ContentManagement;
  translations?: ContentManagementTranslation[];
}

// State interfaces
export interface ContentManagementState {
  versions: ContentManagementVersion[];
  contentManagements: ContentManagement[];
  translations: ContentManagementTranslation[];
  loading: boolean;
  error: string | null;
  selectedVersion: ContentManagementVersion | null;
  selectedContent: ContentManagement | null;
  selectedTranslation: ContentManagementTranslation | null;
}

// API Response interfaces
export interface ContentManagementResponse {
  data: ContentManagement[];
  totalCount: number;
  hasNextPage: boolean;
  currentPage: number;
  totalPages: number;
}

export interface ContentManagementVersionResponse {
  data: ContentManagementVersion[];
  totalCount: number;
  hasNextPage: boolean;
  currentPage: number;
  totalPages: number;
}

export interface ContentManagementTranslationResponse {
  data: ContentManagementTranslation[];
  totalCount: number;
  hasNextPage: boolean;
  currentPage: number;
  totalPages: number;
}

// Create/Update payload interfaces
export interface CreateContentManagementVersionPayload {
  status: {
    id: ContentVersionStatusEnum;
  };
  user: {
    id: string;
  };
  effectiveDate: string;
  publishDate?: string;
}

export interface CreateContentManagementPayload {
  version: {
    id: string;
  };
  type: {
    id: ContentManagementTypeEnum;
  };
  reviewCycle: {
    id: ContentReviewCycleEnum;
  };
  autoSave: number;
  settingLanguage: {
    id: string;
  };
  isText: boolean;
  contentDescription: string;
  contentTitle: string;
}

export interface CreateContentManagementTranslationPayload {
  content: string;
  title: string;
  language: {
    id: string;
  };
  contentManagementType: {
    id: string;
  };
}

export interface UpdateContentManagementVersionPayload {
  id: string;
  data: Partial<CreateContentManagementVersionPayload>;
}

export interface UpdateContentManagementPayload {
  id: string;
  data: Partial<CreateContentManagementPayload>;
}

export interface UpdateContentManagementTranslationPayload {
  id: string;
  data: Partial<CreateContentManagementTranslationPayload>;
}
